import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const DashboardService = {}

DashboardService.jumlah_pegawai_per_pengawas = function (data='') {
    return fetch({
        url: '/transaksi/dashboards/jumlah_pegawai_per_pengawas',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

DashboardService.pengawas_belum_pengajuan = function (data='') {
    return fetch({
        url: '/report/pengawas_belum_pengajuan',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

DashboardService.project_belum_pengajuan = function (data='') {
    return fetch({
        url: '/report/project_belum_pengajuan',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

DashboardService.persentase_pegawai_cek_presensi = function (data) {
    return fetch({
        url: '/transaksi/dashboards/persentase_pegawai_cek_presensi',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

DashboardService.persentase_kehadiran_pegawai = function (data) {
    return fetch({
        url: '/transaksi/dashboards/persentase_kehadiran_pegawai',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default DashboardService;
